import { render, staticRenderFns } from "./ListDivisoes.vue?vue&type=template&id=4b1b7bca"
import script from "./ListDivisoes.vue?vue&type=script&lang=js"
export * from "./ListDivisoes.vue?vue&type=script&lang=js"
import style0 from "./ListDivisoes.vue?vue&type=style&index=0&id=4b1b7bca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports